/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    22/07/2018
 */
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '@lemsar/auth/domains/services/auth.service';
import { Observable } from 'rxjs/Observable';
import { map, tap } from 'rxjs/internal/operators';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { RoleType } from '@shared/enum/role-type';
import { Storage } from '@ubud/storage';

@Injectable()
export class UnregisteredGuard implements CanActivate, CanActivateChild {
    public constructor(public auth: AuthService, public router: Router, public authStore: AuthStore, private storage: Storage) {}

    public canActivate(): Observable<boolean> {
        return this.auth.isRegistered().pipe(
            map((registered: boolean) => false === registered),
            tap((unregistered: boolean) => {
                if (!unregistered) {
                    this.storage.get('redirect_uri').then((res: any) => {
                        if (null !== res) {
                            this.router.navigateByUrl(res);
                        }
                    });

                    if (this.authStore.user.hasRole(RoleType.ADMIN)) {
                        this.router.navigate(['dashboards']);
                    } else {
                        this.router.navigate(['institutions']);
                    }
                }
            }),
        );
    }

    public canActivateChild(): Observable<boolean> {
        return this.canActivate();
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/guards/unregistered.guard.ts